<div class="page-title-area">
  <div class="container">
    <div class="page-title-content">
      <ul>
        <li><a routerLink="/">Inicio</a></li>
        <li><a routerLink="/configurar-administracion">Configuración
          Administración</a></li>
        <li><a routerLink="/doctores-listado">Listado de Doctores</a></li>
        <li>Modificar Doctor</li>
      </ul>
      <h2>Modificar Doctor</h2>
      <h4 *ngIf="this.signoDoctor">{{signoDoctor.nombre}}</h4>
    </div>
  </div>
  <div class="shape9"><img src="assets/img/shape-signomedico.png" alt="image" width="10%"></div>
</div>

<div class="andorra-apply-content ptb-70  animate__animated animate__fadeIn">
  <div class="container">
    <div class="row mx-auto">
      <div class="col-lg-12 col-md-12">
        <div class="apply-form">
          <form [formGroup]="form" (ngSubmit)="updateDoctor()">

            <div class="row m-5">

              <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
                <div class="form-group">
                  <mat-form-field class="example-full-width" appearance="fill" [style.width.%]=100>
                    <mat-label>Doctor</mat-label>
                    <input formControlName="doctor" matInput placeholder="Doctor"
                      [class.is-invalid]="doctorNoValido" autocomplete="off">
                    <mat-error *ngIf="doctorNoValido">Ingrese un
                      doctor</mat-error>
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div class="row m-5">

              <div class="col-lg-4 col-sm-4 col-md-4 col-xs-12">
                <div class="form-group">
                  <mat-form-field appearance="fill">
                    <mat-label>Especialidad</mat-label>
                    <mat-select formControlName="especialidad" [(ngModel)]="especialidadSeleccionada">
                      <mat-option *ngFor="let especialidad of especialidades"
                        [value]="especialidad._id">{{especialidad.concepto}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="especialidadNoSeleccionada">Seleccione una especialidad </mat-error>
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div class="row m-5">

              <div class="col-lg-8 col-sm-8 col-md-8 col-xs-12">
                <div class="form-group">
                  <mat-form-field appearance="fill" [style.width.%]=100>
                    <mat-label>Centros Propios</mat-label>
                    <mat-select formControlName="centro" multiple [(ngModel)]="centrosSeleccionados">
                      <mat-option *ngFor="let centro of centros" [value]="centro._id">{{centro.concepto}}
                      </mat-option>
                    </mat-select>
                    <mat-hint>(Puede seleccionar más de uno o ninguno, no es requerido)</mat-hint>
                  </mat-form-field>
                </div>
              </div>

            </div>

            <div class="row m-5">

              <div class="col-xs-12">
                <div class="form-group">
                  <mat-slide-toggle formControlName="activo">Activo</mat-slide-toggle>
                </div>
              </div>

            </div>

            <div class="row m-5">

              <div class="col-lg-4 col-md-4">
                <button type="button" routerLink="/doctores-listado"
                  class="btn btn-warning">Cancelar</button>
              </div>

              <div class="col-lg-4 col-md-4">
                <button [disabled]="!form.valid" type="submit">Guardar</button>
              </div>

            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>